export const checkExternalRoute = (to) => {
  const isExternal =
    to.startsWith("https://") ||
    to.startsWith("http://") ||
    to.startsWith("mailto:") ||
    to.startsWith("tel:");
  return isExternal;
};
